import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    description: 'Title of this API key section',
    defaultMessage: 'API Settings',
    id: 'm4ap3x',
  },
});

export default messages;
